import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Read out our Frequently Asked Questions (FAQs) which cover almost all your questions and queries regarding CViewSurvey, online and offline App. Know about our pricing, data security, payment options, and other survey related queries.' },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'frequently asked questions, online and offline survey, FAQs' }
    ]);

    this.setTitle('Frequently Asked Questions (FAQs) | Online and Offline Survey | CViewSurvey');
    // End SEO Meta Description
  }

  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description

  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();
  }

}
